// extracted by mini-css-extract-plugin
export var quantityInput = "_iy-0";